import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IEquisActionCardIcon } from '@tn-equis/core/components/action-card';
import { EquisSizes } from '@tn-equis/core/utils';
import { BreadcrumbService } from 'src/app/core/services/breadcrumb/breadcrumb.service';

import { TEXTS_VARIABLE } from 'src/app/shared/constants/constants-texts';
import { QuestionItem } from 'src/app/shared/models/questionItem';
import { environment } from 'src/environments/environment';
import { qualtricsScript } from 'src/app/shared/snippets/qualtrics';
import { FaqsDataLayer } from 'src/app/shared/models/seo/faqsDataLayer';
import { NavigatorService } from 'src/app/shared/services/navigator/navigator.service';
import { SeoJsonLdService } from 'src/app/core/services/seoJsonLd/seoJsonLd.service';
import { SeoService } from 'src/app/shared/services/seo-service/seo.service';
import { ChatFrom } from 'src/app/shared/constants/chatFrom';

@Component({
  selector: 'app-question-info',
  templateUrl: './questionInfo.component.html',
  styleUrls: ['./questionInfo.component.scss'],
})
export class QuestionInfoComponent implements OnInit, OnDestroy {
  question!: QuestionItem;
  texts = TEXTS_VARIABLE;
  equisLoadingSize: any = 'large';
  surveyId = environment.seo.surveyId;
  icon: IEquisActionCardIcon = {
    type: 'icon',
    value: 'icon-message',
    size: EquisSizes.MEDIUM,
  };
  public isApp: boolean = this.navigatorService.isApp;

  constructor(
    private activatedRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private faqsDataLayer: FaqsDataLayer,
    private navigatorService: NavigatorService,
    private seoJsonLdService: SeoJsonLdService,
    private seoService: SeoService,
  ) {
    this.navigatorService.isQuestion.next(true);
  }

  ngOnDestroy(): void {
    this.navigatorService.isQuestion.next(false);
  }

  ngOnInit(): void {
    this.question = this.activatedRoute.snapshot.data?.['question'];
    this.breadcrumbService.setBreadcrumb({
      parentId: this.question?.parentId,
      name: this.question?.slug,
      type: this.question?.__typename,
      id: this.question?.sys.id,
    });

    this.appendScript(document, this.createScript(document, qualtricsScript));
    this.setDatalayerValues();
    this.navigatorService.setTitle(this.question?.title);
    this.seoJsonLdService.createJsonLdScriptQuestion(this.question);
    this.seoService.updateDescriptionMetaTag(this.question.text);
  }

  private setDatalayerValues(): void {
    this.faqsDataLayer.setData(
      this.question?.title,
      this.question?.publicPrivateModel,
      this.question?.vertical,
      this.question?.sys.id,
    );

    this.faqsDataLayer.saveData(window);
  }

  click(question: QuestionItem): void {
    this.router.navigate(['/chat'], {
      state: {
        variables: {
          faqs_vertical: question.vertical,
          faqs_entry_id: question.sys.id,
          faqs_title: question.title,
        },
        chatFrom: ChatFrom.CHAT_FAQ_QUESTION,
        initialChatMessage: question.initialChatMessage,
      },
    });
  }

  private createScript(
    document: Document,
    scriptString: string,
  ): HTMLScriptElement {
    const script: HTMLScriptElement = document.createElement('script');
    script.innerHTML = scriptString;
    return script;
  }

  private appendScript(document: Document, script: HTMLScriptElement): void {
    document.body.appendChild(script);
  }
}
